module.exports = __webpack_public_path__ + "img/2_no.7e53a8c9.svg";